const SRC_TYPE_HTML = "html";
const SRC_TYPE_URL = "url";
const MIN_WIDTH = 35;
const INIT_WIDTH = 350;
const MAX_WIDTH = 940;
const MIN_HEIGHT = 35;
const INIT_HEIGHT = 550;
const MAX_HEIGHT = 1200;
const DEFAULTS_CONFIG = { alignment: "center" };
const htmlButtonsTypes = { html: "html", adsense: "adsense" };
const DEFAULTS_VIEWER = {};
export {
  DEFAULTS_CONFIG,
  DEFAULTS_VIEWER,
  INIT_HEIGHT,
  INIT_WIDTH,
  MAX_HEIGHT,
  MAX_WIDTH,
  MIN_HEIGHT,
  MIN_WIDTH,
  SRC_TYPE_HTML,
  SRC_TYPE_URL,
  htmlButtonsTypes
};
//# sourceMappingURL=defaults.js.map
